<template>
  <div class="row">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.productOptions')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-lg-12 col-md-10 col-sm-12 ">
      <div class="card">
        <div class="card-content row">
          <div class="col-sm-12">
            <div class="pull-right" style="position:relative;z-index:2">
              <router-link class="btn btn-info btn-icon add mar-bt-20" title="" :to="{ path: 'product-option/add'}">
                <img src="/static/img/icons/add.png">
                {{ $t('general.add') }}
              </router-link>
            </div>
          </div>
          <table class="table align-center width-table" ref="sortableTable">
            <thead>
              <tr>
                <th width="10%">{{$t('companyOptions.id')}}</th>
                <th width="10%">{{$t('companyOptions.image')}}</th>
                <th width="30%">{{$t('companyOptions.name')}}</th>
                <th width="20%">{{$t('companyOptions.type')}}</th>
                <th width="20%">{{$t('companyOptions.active')}}</th>
                <th width="40%"></th>
              </tr>
            </thead>
            <draggable v-model="optionData" :sort="false" :element="'tbody'" @end="adjustSort">
              <template v-for="(item, index) in optionData">
                <tr class="sortableRow" :key="item.id">
                  <!-- <td >
                      <i style="cursor: move" class="fa fa-arrows sortHandle"></i>
                  </td> -->
                  <td>{{ item.id }}</td>
                  <td >
                    <div class="cell">
                      <div class="image-table">
                        <img v-bind:src="(item.image[0].url)?item.image[0].url : ''" />
                      </div>
                    </div>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.type }}</td>
                  <td>
                    <template>
                      <p-switch v-model="item.active" type="success" @input="handleActive(item)"></p-switch>
                    </template>
                  </td>
                  <td>
                    <div class="edit" @click="goToRecord(item,[],[], $event)">
                      <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                    </div>
                  </td>
                </tr>
              </template>
            </draggable>
          </table>
        </div>
      </div>
    </div>
    <div class="space_for_alert_box" style="height: 100px; width: 100%;"></div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      // GeneralTopBar,
      PSwitch,
      [Input.name]: Input,
      draggable
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isTable: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.token = this.$session.get('token')
      this.getData()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    data () {
      return {
        loading: true,
        loading2: true,
        token: null,
        apiUrl: null,
        optionData: []
      }
    },
    methods: {
      handleRefresh () {
        this.getData()
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/product-option/edit/')
      },
      getData () {
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-company-options', 'GET', data, (response) => {
          if (response.status === true) {
            this.optionData = response.data.options

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      handleActive (item) {
        this.loading = true
        let id = item.id
        let data = {}
        var companyID = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')
        data.company_id = companyID
        data.option = {
          id: item.id,
          active: item.active
        }
        this.apiRequest('/save-option/' + id, 'PUT', data, (response) => {
          if (response.status === true) {
            this.loading = false
            this.errors.clear()
            swal({'text': this.$t('menuLink.updated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            this.loading = false
            // this.handleErrors(response.errors)
          }
        })
      },
      adjustSort () {
        // TO DO
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ProductOptions/ProductOptions.vue